// A marca: nome e logo que a revenda mostra aos clientes dela.
//
// Duas leituras, e a diferença importa (ver api/interno/web/marca.go):
//   - `doEndereco` é a da tela de LOGIN — o servidor responde pelo nome
//     pedido (`webmail.cliente.com.br`), porque ainda não sabe quem é a pessoa;
//   - `daConta` é a de DEPOIS do login — a da revenda dona da caixa.

import { api } from "./cliente";
import type { components } from "./contrato";
import type { Resposta } from "./tipos";

export type Marca = components["schemas"]["Marca"];
export type MarcaDaConta = Resposta<"/conta/marca">;
export type MarcaDaRevenda = Resposta<"/revendas/{uuid}/marca">;

export const doEndereco = () => api.get<Marca>("/marca");
export const daConta = () => api.get<MarcaDaConta>("/conta/marca");

export const daRevenda = (uuid: string) => api.get<MarcaDaRevenda>(`/revendas/${uuid}/marca`);

/**
 * `logo` tem TRÊS estados, e o tipo os mantém separados:
 * ausente (`undefined`) mantém o atual, `null` tira, texto troca.
 * Mandar `logo: undefined` no JSON é o mesmo que não mandar — o
 * `JSON.stringify` descarta —, e é isso que faz "salvar só o nome" não
 * apagar o logo.
 */
export const salvar = (uuid: string, corpo: { nome: string; logo?: string | null }) =>
  api.put<MarcaDaRevenda>(`/revendas/${uuid}/marca`, corpo);

export const voltarAoPadrao = (uuid: string) => api.delete<void>(`/revendas/${uuid}/marca`);
